import { useRef, useEffect } from "react";
import gsap from "gsap";

export default function Drawer({ isOpen, children, className }) {
  const drawerRef = useRef();
  const innerRef = useRef();

  useEffect(() => {
    const drawer = drawerRef.current;
    const content = innerRef.current;

    if (!drawer || !content) return;

    if (isOpen) {
      // Set height to 0 first so animation works from closed state
      drawer.style.height = '0px';

      // Measure full height
      const fullHeight = content.scrollHeight;

      // Animate to full content height
      gsap.to(drawer, {
        height: fullHeight,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => {
          drawer.style.height = "auto"; // allow dynamic resizing
        }
      });
    } else {
      // Fix height before collapsing
      drawer.style.height = `${drawer.scrollHeight}px`;

      gsap.to(drawer, {
        height: 0,
        opacity: 0,
        duration: 0.4,
        ease: "power2.in"
      });
    }
  }, [isOpen]);

  return (
    <div
      ref={drawerRef}
      className={className}
      style={{ overflow: "hidden", height: 0, opacity: 0 }}
    >
      <div ref={innerRef}>
        {children}
      </div>
    </div>
  );
}